import React, { useState, useEffect, useContext } from "react";
import ReactPaginate from "react-paginate";
import { filterDataContext } from "../../../App";
import { getDataFromApi } from "../../../APIs";
import { EVENTS_API, NOFILTEREVENTS } from "../../../constants";
import EventMiniCard from "../components/EventMiniCard";
import "./style.css";
import { useSearchParams } from "react-router-dom";
import { getCurrentDate, scrollIntoView } from "../../../utils/func";
import EventLoader from "../../../components/Loaders/Event";

const EventsPagination = ({
  searchParams,
  setSearchParams,
  setBottomSheetView,
}) => {
  const {
    filteredEventParams,
    selectedSport,
    filteredParams,
    containerRef,
    viewMoreClicked,
    setViewMoreClicked,
    bottomSheetview,
    setMaxPriceInput,
    setMinPriceInput,
    setTicketAvailabiltyInput,
    setFilterSearchInput,
  } = useContext(filterDataContext);
  const [data, setData] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [eventPageLoader, setEventPageLoader] = useState(false);
  const itemsPerPage = 10;
  const pageSteps = 3;

  const fetchData = async (url) => {
    try {
      setEventPageLoader(true);
      const response = await getDataFromApi(url);
      setEventPageLoader(false);
      if (response) {
        return response.data;
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const getData = async () => {
    let getPageParam = searchParams.get("page");
    let pageSize = "";
    if (getPageParam) {
      pageSize = `&page=${getPageParam}`;
    }
    let result = "";
    if (filteredEventParams.length > 0) {
      result = await fetchData(
        `${EVENTS_API}${filteredEventParams}&sport_type=${selectedSport}${pageSize}`
      );
    } else {
      result = await fetchData(
        `${NOFILTEREVENTS}&sport_type=${selectedSport}${pageSize}`
      );
    }
    if (result) {
      setTotalPages(Math.ceil(result.pagination.total_size / itemsPerPage));
      setData(result.data);
      if (viewMoreClicked) {
        scrollIntoView(containerRef);
      }
    }
  };

  useEffect(() => {
    if (viewMoreClicked) {
      scrollIntoView(containerRef);
      setViewMoreClicked(false);
    }
  }, [viewMoreClicked]);

  useEffect(() => {
    if (selectedSport) {
      getData();
    }
  }, [filteredEventParams, searchParams.get("page"), selectedSport]);

  const handlePageClick = (selected) => {
    if (selected.selected === 0) {
      searchParams.delete("page");
    } else {
      if (selected.selected !== searchParams.get("page")) {
        searchParams.set("page", selected.selected + 1);
      }
    }
    setSearchParams(searchParams);
  };

  const handleResetFilters = () => {
    setSearchParams({ sport_type: searchParams.get("sport_type") });
    setMaxPriceInput("");
    setMinPriceInput("");
    setTicketAvailabiltyInput("");
    setFilterSearchInput("");
  };

  return (
    <>
      {eventPageLoader ? (
        <>
          <EventLoader />
          <EventLoader />
          <EventLoader />
          <EventLoader />
          <EventLoader />
          <EventLoader />
          <EventLoader />
        </>
      ) : data?.length > 0 ? (
        data?.map((events, index) => {
          return (
            <EventMiniCard
              item={events}
              key={index}
              searchParams={searchParams}
              setSearchParams={setSearchParams}
            />
          );
        })
      ) : (
        <>
          <div className="no_eventFound">
            <div className="no_evenFound_Msg">
              <p>No Events found</p>
              <p>This probably is the result of conflicting filter settings.</p>
            </div>
            <button onClick={handleResetFilters}>Reset Filter</button>
          </div>
        </>
      )}

      {totalPages > 1 && data?.length > 0 ? (
        <div className="events_Pagination">
          <ReactPaginate
            pageCount={totalPages}
            pageRangeDisplayed={pageSteps}
            onPageChange={handlePageClick}
            previousLabel="<"
            previousClassName={totalPages < 3 ? "dontShow" : "previous"}
            nextLabel=">"
            nextClassName={totalPages < 3 ? "dontShow" : "next"}
            breakLabel="..."
            containerClassName="pagination"
            forcePage={
              searchParams.get("page") ? searchParams.get("page") - 1 : 0
            }
            activeClassName="active"
          />
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default EventsPagination;
